import Button from '@/common/components/Button'
import SelectController from '@/common/components/SelectController'
import { filterOptions } from '@/common/constants/filterOptions.constant'
import useDebounce from '@/common/hooks/useDebounce'
import { Mapper } from '@/common/services/mapper'
import { useMaintenanceWorkflowValidDiagnosticEntries } from '@/features/maintenanceWorkflow/hooks/useMaintenanceWorkflowValidDiagnosticEntries'
import CreateForwardingDirectiveEntryFormStepAccordion from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepAccordion'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { DirectiveDiagnosticValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { MaintenanceWorkflowValidDiagnosticEntriesTransformer } from '@/features/maintenanceWorkflow/services/maintenanceWorkflowValidDiagnosticEntriesTransformer'
import { useFormContext, useWatch } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { FilterOptionOption } from 'react-select'

const DirectiveDiagnosticFormStepPending = ({
  state,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic>) => {
  const { id: workflowId } = useParams()

  const { increaseStep } = useCreateForwardingsFormStore()

  const [search, setSearch] = useDebounce('')

  const { control } = useFormContext<DirectiveDiagnosticValidationSchema>()

  const { diagnostic: watchDiagnostic } = useWatch({
    control,
  })

  const { data: diagnosticsOptions } = useMaintenanceWorkflowValidDiagnosticEntries({
    workflowId,
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: MaintenanceWorkflowValidDiagnosticEntriesTransformer.optionsTransformer(),
    }),
  })

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Selecionar o diagnóstico e orçamento"
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="diagnostic"
            options={diagnosticsOptions}
            label="Diagnóstico e orçamento selecionado"
            operationKlassToCheckPermission="Client::Maintenance::Workflows::FilterValidDiagnosticEntries"
            filterOption={
              filterOptions as unknown as (option: FilterOptionOption<unknown>, inputValue: string) => boolean
            }
            onInputChange={setSearch}
          />

          <div className="flex items-center justify-end">
            <div className="flex items-center gap-2">
              <Button disabled={!watchDiagnostic} onClick={increaseStep}>
                Confirmar
              </Button>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default DirectiveDiagnosticFormStepPending
